/** AI-Vis user roles — aligned with backend `UserRole`. */

export const ROLE_LABELS = {
  system_admin: 'System Admin',
  company_admin: 'Company Admin',
  company_member: 'Company Member',
  campaign_viewer: 'Client Viewer',
};

/** Roles assignable via the Members table's role editor (matches backend `EDITABLE_ROLES`). */
export const ROLE_OPTIONS = [
  { value: 'company_member', label: 'Company Member' },
  { value: 'company_admin', label: 'Company Admin' },
  { value: 'campaign_viewer', label: 'Client Viewer' },
];

export function hasAdminConsoleAccess(user) {
  return user?.role === 'system_admin' || user?.role === 'company_admin';
}

/** Company admins and system admins may edit other users' roles from the Members table. */
export function canEditUserRoles(user) {
  return user?.role === 'system_admin' || user?.role === 'company_admin';
}

export function isCampaignViewer(user) {
  return user?.role === 'campaign_viewer';
}

export function isSystemAdmin(user) {
  return user?.role === 'system_admin';
}

/** Brands tab and brand management — hidden for campaign viewers. */
export function canAccessBrands(user) {
  return !isCampaignViewer(user);
}

/** Only company / system admins may delete campaigns (matches backend). */
export function canDeleteCampaigns(user) {
  return user?.role === 'system_admin' || user?.role === 'company_admin';
}

export function sidebarRoleLabel(user) {
  if (!user?.role) return '';
  return ROLE_LABELS[user.role] || user.role;
}
